import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const CARTFUNNELONBEHALFUSERFULLNAMEITEMBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "placeholder",
  "required"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  cartFunnelOnBehalfUserFullNameItemBlockDescriptor: _generatedCartFunnelOnBehalfUserFullNameItemBlockDescriptor,
  cartFunnelOnBehalfUserFullNameItemBlockBlocDefinition,
  cartFunnelOnBehalfUserFullNameItemBlockDashboardLayout,
  cartFunnelOnBehalfUserFullNameItemBlockConfig,
  cartFunnelOnBehalfUserFullNameItemBlockResolveConfig,
  cartFunnelOnBehalfUserFullNameItemBlockProperties,
} = doodBlockConfig(
  {
    name: "Cart funnel / On behalf user full name input",
    componentType: 'CartFunnelOnBehalfUserFullNameItemBlockComponent',
    category: 'cart',
    description: "Cart funnel / On behalf user full name input.",
    keywords: [],
    allowedIn: [
      { bloc: "CartFunnelFormBlockComponent", slot: "items" },
    ],
    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.title.label",
        help: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.title.help",
      }
    }),
    placeholder: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.placeholder.label",
      }
    }),
    required: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.required.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.cart-funnel-on-behalf-user-full-name-item.fieldset.field.label",
            fields: ["title", "placeholder", "required"],
          },
        ],
      },
    ],
  })
);

export function cartFunnelOnBehalfUserFullNameItemBlockDescriptor(): IBlockDescriptor;
export function cartFunnelOnBehalfUserFullNameItemBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function cartFunnelOnBehalfUserFullNameItemBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedCartFunnelOnBehalfUserFullNameItemBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedCartFunnelOnBehalfUserFullNameItemBlockDescriptor, cartFunnelOnBehalfUserFullNameItemBlockProperties, fieldOrder);
}

export {
  cartFunnelOnBehalfUserFullNameItemBlockBlocDefinition,
  cartFunnelOnBehalfUserFullNameItemBlockDashboardLayout,
  cartFunnelOnBehalfUserFullNameItemBlockProperties,
  cartFunnelOnBehalfUserFullNameItemBlockConfig,
  cartFunnelOnBehalfUserFullNameItemBlockResolveConfig,
};

export type CartFunnelOnBehalfUserFullNameItemBlockConfig = typeof cartFunnelOnBehalfUserFullNameItemBlockConfig;
